import React from "react";

import icon from "./icon.svg";

function PartlyCloudyIcon({ className }: { className: string }) {
  return <img className={className} src={icon} alt="Partly Cloudy" />;
}

export { PartlyCloudyIcon };
